interface PlanPricing {
  monthly: number;
  annually: number; // monthly-equivalent of the annual price
  annuallyTotal: number; // raw yearly total — for the "Billed annually — €N/yr" disclaimer
}

export interface PricingData {
  Starter: PlanPricing;
  Pro: PlanPricing;
  Team: PlanPricing;
}

export const usePricing = () => {
  const { data: pricing, error, refresh, status } = useFetch<PricingData>("/api/stripe/pricing", {
    lazy: false,
    server: true,
    dedupe: "defer",
  });

  return {
    pricing,
    error,
    refresh,
    status,
    isLoading: computed(() => status.value === "pending"),
  };
};
